import * as types from './mutation-types'
// 异步提交改变 islogin
export const loginAction = ({commit}, islogin) => {
  commit(types.ISLOGIN, islogin)
}
// 设置token
export const setToken = ({commit}, token) => {
  commit(types.SET_TOKEN, token)
}
// 设置学生详情Id
export const setRowData = ({commit}, rowdata) => {
  commit(types.STUDENT_DETAILSID, rowdata)
}
// 异步提交改变 islogin
export const webSocketMsgAction = ({commit}, webSocketMsg) => {
  commit(types.WEBSOCKET_MSG, webSocketMsg)
}
// 异步提交改变 连接状态
export const webSocketConnectAction = ({commit}, webSocketConnect) => {
  commit(types.WEBSOCKET_CONNECT, webSocketConnect)
}



// WEBPACK FOOTER //
// ./src/store/actions.js